var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserOctagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/user-octagon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-octagon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5099 4.35L11.5699 0.92C10.5999 0.36 9.39992 0.36 8.41992 0.92L2.48992 4.35C1.51992 4.91 0.919922 5.95 0.919922 7.08V13.92C0.919922 15.04 1.51992 16.08 2.48992 16.65L8.42992 20.08C9.39992 20.64 10.5999 20.64 11.5799 20.08L17.5199 16.65C18.4899 16.09 19.0899 15.05 19.0899 13.92V7.08C19.0799 5.95 18.4799 4.92 17.5099 4.35ZM9.99992 5.84C11.2899 5.84 12.3299 6.88 12.3299 8.17C12.3299 9.46 11.2899 10.5 9.99992 10.5C8.70992 10.5 7.66992 9.46 7.66992 8.17C7.66992 6.89 8.70992 5.84 9.99992 5.84ZM12.6799 15.16H7.31992C6.50992 15.16 6.03992 14.26 6.48992 13.59C7.16992 12.58 8.48992 11.9 9.99992 11.9C11.5099 11.9 12.8299 12.58 13.5099 13.59C13.9599 14.25 13.4799 15.16 12.6799 15.16Z",
    fill: "#7E92A2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOctagon);
export default __webpack_public_path__ + "static/media/user-octagon.12a26f8b00263e17e2608ac4b18fbb61.svg";
export { ForwardRef as ReactComponent };